import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { COPY, DEFAULT_STATEMENTS } from "@/lib/copy";

let _cache = null;

export const usePlatformCopy = () => {
  const [data, setData] = useState(
    _cache || {
      disclaimers: {
        independent: COPY.disclaimers.independent,
        not_replacement: COPY.disclaimers.notReplacement,
        voluntary: COPY.disclaimers.voluntary,
        governance: COPY.disclaimers.governance,
        principle: COPY.principle,
      },
      declaration_statements: DEFAULT_STATEMENTS,
      ballot_secrecy_warning: COPY.ballotWarning,
      test_mode: true,
      loaded: false,
    }
  );

  useEffect(() => {
    if (_cache) return;
    api
      .get("/public/settings/copy")
      .then((r) => {
        _cache = { ...r.data, loaded: true };
        setData(_cache);
      })
      .catch(() => {});
  }, []);

  return data;
};
